// extracted by mini-css-extract-plugin
export default {"icon":"PaymentProtectionBanner--icon--52aa1a","banner":"PaymentProtectionBanner--banner--4c2d2c"};